export default __webpack_public_path__ + "static/media/shield_check.93e116cc.svg";